import css from 'styled-jsx/css';
import { MQ_MEDIUM } from 'constants/mq';

export default css`
  .RecipeFirst {
    background: #f5f3f3;
  }

  :global(.RecipeFirst .Figure .ImageCaption) {
    padding-left: 1rem;
  }
`;
